import React from 'react';
import { withRouter, withStyles, Grid, Typography, TableRow, TableCell, Table, TableBody, TableHead, ButtonBase, } from '../../../material-ui';

import MTabsButton from '../../view/MTabsButton';
import MTabPanel from '../../view/MTabPanel';
import Apis from '../../../network/Apis';
import DateUtils from '../../../control/dateutils'
import AnalysisFoot from '../../../model/AnalysisFoot';

class MovieAnalyseFootBall extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            value: 0,
            data: null,
            sameIndex: 0,
            recentHomeSide: false,
            recentSameSide: false,
            recentSameLeague: false,
        };
        console.log('MovieAnalyseFootBall', props);
    }

    componentDidMount() {
        this.getAnalysis();
    }

    componentWillUnmount() {
        this.setState = () => false;
    }

    getAnalysis = async () => {
        let reuslt = await Apis.encryptionAnalysis(this.props.data.match_type, this.props.data.match_id);
        console.log(reuslt);
        if (reuslt.code == 200) {
            let analysis = new AnalysisFoot(reuslt.data);
            this.setState({ data: analysis });
        }
    }

    _handleChange = (val) => {
        this.setState({ value: val });
    }

    _onRecentHomeSide = () => {
        this.setState({ recentHomeSide: !this.state.recentHomeSide })
    }

    _onRecentSameSide = () => {
        this.setState({ recentSameSide: !this.state.recentSameSide })
    }

    _onRecentSameLeague = () => {
        this.setState({ recentSameLeague: !this.state.recentSameLeague })
    }

    _renderItem(match, i) {
        const { classes } = this.props;
        let homecolor = '#0D0D0D';
        let awaycolor = '#0D0D0D';
        if (match.homeScore > match.awayScore) {
            if (match.isHome) {
                homecolor = '#FC2E34';
                awaycolor = '#0D0D0D';
            } else {
                homecolor = '#0D0D0D';
                awaycolor = '#1692E1';
            }
        } else if (match.homeScore < match.awayScore) {
            if (match.isHome) {
                homecolor = '#1692E1';
                awaycolor = '#0D0D0D';
            } else {
                homecolor = '#0D0D0D';
                awaycolor = '#FC2E34';
            }
        } else {
            if (match.isHome) {
                homecolor = '#34CF16';
                awaycolor = '#0D0D0D';
            } else {
                homecolor = '#0D0D0D';
                awaycolor = '#34CF16';
            }
        }
        return (
            <TableRow key={i} style={{ height: 48, width: '100%' }}>
                <TableCell align='left' className={classes.tableBody} style={{ paddingLeft: 8, borderBottom: 'solid 1px #F7F7F7' }}>
                    <Typography style={{ fontSize: 11, color: '#878787' }}>{DateUtils.dateFormatYMD(match.time, '/')}</Typography>
                    <Typography style={{ fontSize: 11, color: '#878787' }}>{match.league}</Typography>
                </TableCell>
                <TableCell align='right' className={classes.tableBody} style={{ fontSize: 11, color: '#FC2E34', borderBottom: 'solid 1px #F7F7F7' }}>
                    <Typography noWrap={true} style={{ fontSize: 11, color: homecolor, maxWidth: '20vw' }} >{match.homeName}</Typography>
                </TableCell>
                <TableCell align='center' className={classes.tableBody} style={{ borderBottom: 'solid 1px #F7F7F7' }}>
                    <Typography style={{ fontSize: 11, color: '#FC2E34' }}>{match.homeScore + ':' + match.awayScore}</Typography>
                    <Typography style={{ fontSize: 11, color: '#878787' }}>{match.homeHalfScore + ':' + match.awayHalfScore}</Typography>
                </TableCell>
                <TableCell align='left' className={classes.tableBody} style={{ fontSize: 11, color: '#0D0D0D', borderBottom: 'solid 1px #F7F7F7' }}>
                    <Typography noWrap={true} style={{ fontSize: 11, color: awaycolor, maxWidth: '20vw' }} >{match.awayName}</Typography>
                </TableCell>
                <TableCell align='center' className={classes.tableBody} style={{ borderBottom: 'solid 1px #F7F7F7' }}>
                    <Typography style={{ fontSize: 11, color: '#0D0D0D' }}>{match.asiaString}</Typography>
                    <Typography style={{ fontSize: 11, color: '#FC2E34' }}>{match.asiaResult == 0 ? '走' : (match.asiaResult > 0 ? '赢' : '输')}</Typography>
                </TableCell>
                <TableCell align='center' className={classes.tableBody} style={{ borderBottom: 'solid 1px #F7F7F7' }}>
                    <Typography style={{ fontSize: 11, color: '#0D0D0D' }}>{match.daxiaoString}</Typography>
                    <Typography style={{ fontSize: 11, color: '#1692E1' }}>{match.daxiaoResult > 0 ? '大' : (match.daxiaoResult == 0 ? '走' : '小')}</Typography>
                </TableCell>
            </TableRow>
        );
    }

    _renderMacth = (matches) => {
        const { classes, } = this.props;
        const { data } = this.state;
        let analysis = data.getAnalysisCount(matches);
        let all = analysis.win + analysis.fail + analysis.draw;
        let won = analysis.win;
        let draw = analysis.draw;
        let fail = analysis.fail;

        return (
            <Table key style={{ marginTop: 16 }}>
                <TableHead>
                    <TableRow>
                        <TableCell align='left' className={classes.tableHead} style={{ paddingLeft: 8 }}>日期/赛事</TableCell>
                        <TableCell align='right' className={classes.tableHead}></TableCell>
                        <TableCell align='center' className={classes.tableHead}>对阵</TableCell>
                        <TableCell align='left' className={classes.tableHead}></TableCell>
                        <TableCell align='center' className={classes.tableHead}><font style={{ fontSize: 12, color: '#878787' }}>{all + '场'}</font><font style={{ fontSize: 12, color: '#FC2E34' }}> {won + '胜'}</font></TableCell>
                        <TableCell align='center' className={classes.tableHead}><font style={{ fontSize: 12, color: '#34CF16' }}>{draw + '平'}</font><font style={{ fontSize: 12, color: '#FC2E34' }}> {fail + '负'}</font></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {
                        matches.map((item, i) => (
                            this._renderItem(item, i)
                        ))
                    }
                </TableBody>
            </Table>
        );
    }

    render() {
        const { classes, } = this.props;
        const { value, data, recentHomeSide, recentSameSide } = this.state;
        if (!data) {
            return (<Grid></Grid>);
        }

        let homeName = data.getMatchHomeName();
        let awayName = data.getMatchAwayName();
        let history = data.getHistory(recentHomeSide);
        let homeList = data.getRecent(value == 0, recentSameSide, !recentSameSide);
        let awayList = data.getRecent(value == 0, recentSameSide, !recentSameSide);

        let analysis = data.getAnalysisCount(history, !recentSameSide);
        history = history.slice(0, 5);

        return (
            <Grid container direction='column' alignItems='center' justifyContent='center' className={classes.root}>
                <Grid container direction='row' alignItems='center' justifyContent='space-between' style={{ marginTop: 16, marginBottom: 16 }}>
                    <Typography style={{ fontWeight: 'bold', fontSize: 14, color: '#0D0D0D', marginLeft: 8 }}>历史交战</Typography>
                    <ButtonBase onClick={() => this._onRecentHomeSide()} style={{ color: recentHomeSide ? '#1692E1' : '#878787', fontSize: 10, marginRight: 8 }}>同主客</ButtonBase>
                </Grid>
                <Grid container direction='row' alignItems='center' justifyContent='space-around'>
                    <Grid container direction='column' alignItems='center' justifyContent='center' style={{ maxWidth: '30%' }}>
                        <Typography style={{ fontSize: 20, color: '#FC2E34' }}>{analysis.winLv}</Typography>
                        <Typography style={{ fontSize: 12, color: '#0D0D0D' }}>胜率</Typography>
                        <Typography style={{ fontSize: 11, color: '#878787' }}>{analysis.win + '胜' + analysis.draw + '平' + analysis.fail + '负'}</Typography>
                    </Grid>
                    <Grid container direction='column' alignItems='center' justifyContent='center' style={{ maxWidth: '30%' }}>
                        <Typography style={{ fontSize: 20, color: '#FC2E34' }}>{analysis.asiaLv}</Typography>
                        <Typography style={{ fontSize: 12, color: '#0D0D0D' }}>赢盘率</Typography>
                        <Typography style={{ fontSize: 11, color: '#878787' }}>{analysis.asiaWin + '赢' + analysis.asiaFail + '输' + analysis.asiaDraw + '走'}</Typography>
                    </Grid>
                    <Grid container direction='column' alignItems='center' justifyContent='center' style={{ maxWidth: '30%' }}>
                        <Typography style={{ fontSize: 20, color: '#FC2E34' }}>{analysis.dxLv}</Typography>
                        <Typography style={{ fontSize: 12, color: '#0D0D0D' }}>大球率</Typography>
                        <Typography style={{ fontSize: 11, color: '#878787' }}>{analysis.da + '大' + analysis.xiao + '小' + analysis.zou + '走'}</Typography>
                    </Grid>
                </Grid>
                <Grid style={{ width: '100%', height: 1, backgroundColor: '#F7F7F7', marginTop: 8 }}></Grid>
                {
                    this._renderMacth(history)
                }
                <Grid container direction='row' alignItems='center' justifyContent='space-between' style={{ marginTop: 16, marginBottom: 16 }}>
                    <Typography style={{ fontWeight: 'bold', fontSize: 14, color: '#0D0D0D', marginLeft: 8, maxWidth: '50vw' }}>近期状态</Typography>
                    <Grid container direction='row' alignItems='center' justifyContent='flex-end' style={{ maxWidth: '30vw', flex: 1 }}>
                        <ButtonBase onClick={() => this._onRecentSameSide()} style={{ color: recentSameSide ? '#1692E1' : '#878787', fontSize: 10, marginRight: 8 }}>同主客</ButtonBase>
                        <ButtonBase onClick={() => this._onRecentSameSide()} style={{ color: recentSameSide ? '#878787' : '#1692E1', fontSize: 10, marginRight: 8 }}>同赛事</ButtonBase>
                    </Grid>
                </Grid>
                <MTabsButton data={[homeName, awayName]} onChange={(val) => this._handleChange(val)} />
                <Grid container style={{ width: '100%' }}>
                    <MTabPanel value={value} index='0' style={{ width: '100%' }} >
                        {
                            this._renderMacth(homeList)
                        }
                    </MTabPanel>
                    <MTabPanel value={value} index='1' style={{ width: '100%' }} >
                        {
                            this._renderMacth(awayList)
                        }
                    </MTabPanel>
                </Grid>
            </Grid>
        );
    }
}

export default withRouter(withStyles((theme) => ({
    root: {
        width: '100%',
        backgroundColor: '#FFF'
    },
    tableHead: {
        fontSize: 7,
        color: '#898989',
        height: 36,
        margin: theme.spacing(0, 0, 0, 0),
        padding: theme.spacing(0, 0, 0, 0),
        border: 0,
    },
    tableBody: {
        fontSize: 9,
        color: '#0D0D0D',
        margin: theme.spacing(0, 0, 0, 0),
        padding: theme.spacing(0, 0, 0, 0),
        border: 0,
        height: 24,
    },

}))(MovieAnalyseFootBall));